import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ptBR from './locales/pt-BR'
import fr from './locales/fr'
import { resolveLocaleFromIso3 } from './resolveLocale'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    fr,
  },
  silentTranslationWarn: true,
})

export function setLocaleFromIso3(iso3) {
  i18n.locale = resolveLocaleFromIso3(iso3)
}

export default i18n
